import { Box } from '@razorpay/blade/components';
import React, { ReactNode } from 'react';

const ComponentSectionItem = ({ children }: { children?: ReactNode }) => {
  return (
    <Box display={'flex'} flexDirection={'column'}>
      {children}
    </Box>
  );
};

export default ComponentSectionItem;
